import React from "react";
import { Player } from "types/player";

export interface PlayerNameProps {
  isGuest?: boolean;
  lighter?: boolean;
  name?: string;
  lastName: string;
  onlyLastName?: boolean;
  hci?: string | number;
  player?: Player;
}

const PlayerName: React.FC<PlayerNameProps> = props => {
  const { isGuest, name, lastName, lighter, hci, player } = props;

  return (
    <>
      <span
        style={{
          ...(isGuest ? { fontStyle: "italic", paddingRight: 7 } : {}),
          ...(lighter ? { fontWeight: "lighter" } : {}),
        }}
      >
        {`${name} ${lastName}`}
      </span>
      {isGuest && <sup style={{ color: "red" }}>U</sup>}
      {player && !!player.shcp ? <span>{` (${hci} ${player.shcp}) `}</span> : hci && <span>{` (${hci}) `}</span>}
    </>
  );
};

export default PlayerName;
